module.exports = __webpack_public_path__ + "img/monk-and-bela-2.9775342e.svg";